export default (function (_a) {
    var backdropBlur = _a.backdropBlur;
    if (!backdropBlur)
        return "";
    if (typeof backdropBlur === "boolean")
        return "backdrop-filter: blur(10px);";
    return typeof backdropBlur === "number"
        ? "backdrop-filter: blur(".concat(backdropBlur, "px);")
        : "backdrop-filter: blur(".concat(backdropBlur, ");");
});
